module.exports = "/_next/static/images/OgComposableCdp-f1f8b7c5796fa5b540844e9bc96ed01d.png";